export default {
      id: "bullet-usage",
      viewBox: "0 0 4 4",
      url: "static/docker-35e621d613051bbda5b8b67fc5bb152e/images/" + "sprite.svg#bullet-usage",
      toString: function () {
        return this.url;
      }
    }